import Button from "@mui/material/Button";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { useDeleteFolderModal, useFolderRefresh } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const DeleteFolderDialog = () => {
    const { isOpen, closeModal, payload } = useDeleteFolderModal();
    const { refreshFolders } = useFolderRefresh();
    const { response, makeRequest, loading, error } = useApiHook();
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setSubmitRequested(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        refreshFolders();
        if (payload?.onSuccess) {
            payload.onSuccess();
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, refreshFolders, response, submitRequested]);

    const onConfirmHandler = () => {
        if (!payload?.folderId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/folder/delete', 'post', { folderId: payload.folderId });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DeleteForeverIcon fontSize="large" />
                    <Typography variant="h5">Elimina cartella</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        color="error"
                        onClick={onConfirmHandler}
                        disabled={loading}
                    >
                        Si
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        No
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body1">
                    Vuoi davvero eliminare la cartella <strong>{payload?.folderName}</strong>?
                </Typography>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    I file contenuti verranno spostati nella root.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile eliminare la cartella. Riprova.
                    </Alert>
                )}
            </Stack>
        </ResponsiveDialog>
    );
};

export default DeleteFolderDialog;
